import { Badge } from 'shared/ui/Badge';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { Tooltip } from 'shared/ui/Tooltip';

import type { OnboardingStatus } from '../../model';

import { statusMap } from './constants';

interface BadgeIconProps {
  status: OnboardingStatus;
  tooltipText?: string;
}

export function BadgeIcon({ status, tooltipText }: BadgeIconProps) {
  const { text, color } = statusMap[status];

  return (
    <div className="flex items-center gap-2">
      <Badge
        className="min-w-[96px]"
        color={color}
        text={text}
      />
      {tooltipText && (
        <Tooltip
          placement="top"
          content={tooltipText}
        >
          <MaterialIcon className="block cursor-pointer text-[16px] text-slate-300 hover:text-deep-blue-500">
            info
          </MaterialIcon>
        </Tooltip>
      )}
    </div>
  );
}
